import { request } from './request'

// 发起各种请求
const reqArr = ['get', 'post', 'put', 'delete', 'patch']
const modules = {}
reqArr.forEach(item => {
  modules[item] = (url, data = {}) => {
    const requestObj = {
      method: item,
      url
    }
    if (item === 'get') {
      requestObj.params = data
      if (url.indexOf('export') !== -1 || url.indexOf('Export') !== -1) {
        requestObj.responseType = "blob"
      }
    } else if (item === 'post') {
      if (['/v1/sqgj/uc/session/captcha/request_image_code',
        '/v1/sqgj/uc/session/username_login',
        '/v1/sqgj/uc/session/smscode_login',
        '/v1/sqgj/uc/session/captcha/request_sms_code',
        '/v1/sqgj/uc/session/logout',
        '/video_learning/person/loginSuccess',
        '/video_learning/getSessionPerson'
      ].includes(url)) {
        requestObj.data = data
      } else {
        let formData = new FormData()
        for(let key in data) {
          formData.append(key, data[key])
        }
        requestObj.data = formData
      }
    } else {
      requestObj.data = data
    }
    return request(requestObj)
  }
})

export default modules
